<div class="authentication-bg min-vh-100">
  <div class="bg-overlay bg-white"></div>
  <!-- Language Switcher -->
  <div class="language-switcher-container">
    <app-language-switcher></app-language-switcher>
  </div>
  <div class="container">
    <div class="col-row">
      <div class="col-md-6">
        <div class="w-full">
          <div class="mb-4 mb-md-5 responsive-auth-header">
            <a routerLink="/" class="d-block auth-logo">
              <div class="d-flex gap-3">
                <img src="assets/images/HC-logo.svg" alt="HotelCard Logo" class="logo" />
                <img src="assets/images/hotelcard-text.svg" alt="HotelCard" class="hotelcard-text" />
                <span class="mt-3 responsive-divider">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="30"
                    viewBox="0 0 2 30"
                    fill="none"
                    >
                    <path d="M1.24854 2.18557e-08L1.24853 30" stroke="white" />
                  </svg>
                </span>
                <span class="text-white extranet">Extranet</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="row justify-content-center my-auto">
        <div class="col-lg-6">
          <div class="responsive-center-card responsive-auth-page-card">
            <div class="card auth-cover-card overflow-hidden">
              <div class="row g-0">
                <!-- end col -->
                <div class="col-lg-12">
                  <div
                    class="login-form-card bg-white h-100 d-flex align-items-center justify-content-center auth-card"
                    >
                    <div class="w-full">
                      @if (emailSent) {
                        <div class="text-center">
                          <div class="mb-4">
                            <lucide-icon name="mail-check" class="text-success icon-xxl"></lucide-icon>
                          </div>
                          <h5 class="welcome-text mb-3">{{ 'AUTH.PASSWORD_RECOVERY.SUCCESS_TITLE' | translate }}</h5>
                          <p class="text-muted mb-4">
                            {{ 'AUTH.PASSWORD_RECOVERY.SUCCESS_MESSAGE' | translate: { email: email } }}
                          </p>
                          <p class="text-muted small">
                            {{ 'AUTH.PASSWORD_RECOVERY.RETRY_PROMPT' | translate }}
                            <a href="javascript:void(0)" (click)="emailSent = false" class="text-primary">{{ 'AUTH.PASSWORD_RECOVERY.RETRY_LINK' | translate }}</a>.
                          </p>
                          <div class="mt-4">
                            <hc-button variant="primary" [fullWidth]="true" (clicked)="goToLogin()">
                              {{ 'AUTH.PASSWORD_RECOVERY.BACK_TO_LOGIN' | translate }}
                            </hc-button>
                          </div>
                        </div>
                      } @else {
                        <div class="text-white-50 mb-4">
                          <h5 class="welcome-text">{{ 'AUTH.PASSWORD_RECOVERY.TITLE' | translate }}</h5>
                        </div>
                        <form #resetForm="ngForm" (ngSubmit)="onSubmit(resetForm)">
                          <div class="mt-5">
                            <!-- TODO: account pages use dark theme — needs design review before migrating to hc-input -->
                            <hc-form-field
                              label="{{ 'AUTH.PASSWORD_RECOVERY.EMAIL_LABEL' | translate }}"
                              [required]="true"
                              [error]="emailError || getFieldError(emailField)"
                              helper="{{ 'AUTH.PASSWORD_RECOVERY.EMAIL_HELPER' | translate }}">
                              <hc-input
                                [placeholder]="'AUTH.PASSWORD_RECOVERY.EMAIL_PLACEHOLDER' | translate"
                                type="email"
                                name="email"
                                [(ngModel)]="email" (ngModelChange)="onEmailChange()"
                                required
                                email
                                [hasError]="!!emailError || (emailField.invalid && (emailField.dirty || emailField.touched || submitted))"
                                #emailField="ngModel"
                              ></hc-input>
                            </hc-form-field>
                          </div>

                          <div class="mt-4">
                            <hc-button
                              variant="primary"
                              [fullWidth]="true"
                              type="submit"
                              size="md"
                              [disabled]="loading">
                              {{ loading ? ('AUTH.PASSWORD_RECOVERY.SUBMITTING' | translate) : ('AUTH.PASSWORD_RECOVERY.SUBMIT' | translate) }}
                            </hc-button>
                          </div>

                          <div class="mt-4">
                            <a href="javascript:void(0)" (click)="goToLogin()" class="text-decoration-underline forgot-password">
                              ← {{ 'AUTH.PASSWORD_RECOVERY.BACK_TO_LOGIN' | translate }}
                            </a>
                          </div>
                        </form>
                        <!-- end form -->
                      }
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
              <!-- end row -->
            </div>
            <!-- end card -->
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
  </div>
  <!-- end container -->
</div>
<!-- end authentication section -->
